var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const executeCommand_1 = require("./executeCommand");
function register(context) {
    return (item) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const data = item.data;
        if (data) {
            const plugin = context.plugins[data.pluginId];
            if (!plugin)
                return item;
            if (!((_a = plugin.codeLens) === null || _a === void 0 ? void 0 : _a.resolve))
                return item;
            const resolvedOriginalItem = yield plugin.codeLens.resolve(data.originalItem);
            item = Object.assign(Object.assign({}, resolvedOriginalItem), { command: resolvedOriginalItem.command ? Object.assign(Object.assign({}, resolvedOriginalItem.command), { command: executeCommand_1.executePluginCommand, arguments: [data.uri, context.plugins.indexOf(plugin), resolvedOriginalItem.command] }) : undefined, range: item.range });
        }
        return item;
    });
}
exports.register = register;
//# sourceMappingURL=codeLensResolve.js.map